import { Box } from '@factorialco/deprecated-design-system'
import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'
import { ImputableProjectForSelectFragment } from 'generated/resources/graphql'

import useFilter from 'modules/core/components/Filter/base/useFilter'
import i18n from 'modules/core/lib/i18n'

import { ImputableProjectSelector } from 'modules/project_management/components/selectors/ImputableProjectSelector'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

interface ImputableProjectFilterProps extends BaseFilterProps {
  employeeId?: string
}

const ImputableProjectFilterComponent = ({ employeeId }: { employeeId?: string }) => {
  const { value, onValueChange } = useFilter<ImputableProjectForSelectFragment[]>()

  return (
    <Box width="s400" flexDirection="column" overflowY="hidden" overflowX="hidden" hideScrollBar>
      <ImputableProjectSelector
        multiple
        onlyActive={false}
        assigned={false}
        value={value ?? []}
        onChange={onValueChange}
        forEmployeeId={employeeId}
        hideBorder
        alwaysOpen
      />
    </Box>
  )
}

const imputableProjectFilter = ({
  expensesContext,
  employeeId,
}: ImputableProjectFilterProps): DataTableFilter<ExpensesExpensableFilter> => {
  return {
    type: FilterType.Entity,
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        nameAttribute: 'name',
        component: () => <ImputableProjectFilterComponent employeeId={employeeId} />,
      },
    ],
    onUpdateValue: () => {
      trackFilters('imputableProject', expensesContext)
    },
    identifier: 'expensesList.imputableProjectFilter',
    path: 'project',
    title: i18n.t('expenses_v2.forms.fields.projects.project'),
  }
}

export default imputableProjectFilter
